module.exports = __webpack_public_path__ + "static/assets/b6a8e4a96ffcd83154ad2c5cbcb52751.mp3";